<template>
  <div class="coach-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">教练管理</span>
      </div>
    </div>

    <!-- 标签页 -->
    <el-tabs v-model="activeTab" class="main-tabs" @tab-change="handleTabChange">
      <!-- 学员分配标签页 -->
      <el-tab-pane label="学员分配" name="assignment">
        <div class="search-bar">
          <el-input placeholder="学员姓名/电话" v-model="searchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="handleSearch">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
          <el-select v-model="searchForm.coachUserId" placeholder="选择教练" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
            <el-option v-for="coach in coachList" :key="coach.id" :label="coach.name" :value="coach.id" />
          </el-select>
          <el-select v-model="searchForm.studentStatus" placeholder="学员状态" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
            <el-option label="潜在学员" value="POTENTIAL" />
            <el-option label="在学学员" value="ACTIVE" />
            <el-option label="已毕业" value="COMPLETED" />
          </el-select>
          <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
            <i class="el-icon-search"></i> 查询
          </el-button>
        </div>

        <div class="section-title">
          <i class="el-icon-tickets"></i> 学员分配列表
        </div>

        <el-table
            v-loading="loading"
            :data="tableData"
            stripe
            border
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column prop="studentName" label="学员姓名" width="100" />
            <el-table-column prop="contactPhone" label="联系电话" width="120" />
            <el-table-column prop="examType" label="报考车型" width="80">
              <template slot-scope="scope">
                <el-tag size="small">{{ scope.row.examType || '-' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="currentSubject" label="当前科目" width="100">
              <template slot-scope="scope">
                <span>{{ getSubjectName(scope.row.currentSubject) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="studentStatus" label="状态" width="90">
              <template slot-scope="scope">
                <el-tag size="small" :type="getStatusTagType(scope.row.studentStatus)">
                  {{ getStatusName(scope.row.studentStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="coachUserName" label="分配教练" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.coachUserName">{{ scope.row.coachUserName }}</span>
                <span v-else class="no-assign">待分配</span>
              </template>
            </el-table-column>
            <el-table-column prop="driverUserName" label="分配司机" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.driverUserName">{{ scope.row.driverUserName }}</span>
                <span v-else class="no-assign">待分配</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" />
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleAssign(scope.row)">分配</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <span class="total-text">共 {{ total }} 条记录</span>
            <el-pagination
              background
              layout="sizes, prev, pager, next"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
            />
          </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 分配弹窗 -->
    <el-dialog title="分配教练和司机" :visible.sync="assignDialogVisible" width="500px">
      <el-form ref="assignForm" :model="assignForm" label-width="100px">
        <el-form-item label="学员姓名">
          <span>{{ assignForm.studentName }}</span>
        </el-form-item>
        <el-form-item label="分配教练">
          <el-select v-model="assignForm.coachUserId" placeholder="请选择教练" filterable style="width: 100%">
            <el-option v-for="coach in coachList" :key="coach.id" :label="coach.name" :value="coach.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="分配司机">
          <el-select v-model="assignForm.driverUserId" placeholder="请选择司机" filterable style="width: 100%">
            <el-option v-for="driver in driverList" :key="driver.id" :label="driver.name" :value="driver.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAssignSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as studentApi from '@/api/studentApi.js'

export default {
  name: 'CoachManage',
  data() {
    return {
      activeTab: 'assignment',
      searchForm: {
        keyword: '',
        coachUserId: '',
        studentStatus: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      coachList: [],
      driverList: [],
      assignDialogVisible: false,
      assignForm: {
        studentId: null,
        studentName: '',
        coachUserId: null,
        driverUserId: null
      }
    }
  },
  created() {
    // 从路由参数读取初始标签页
    const tab = this.$route.query.tab
    if (tab === 'assignment') {
      this.activeTab = tab
    }
    this.loadCoachList()
    this.loadDriverList()
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    async loadCoachList() {
      try {
        const result = await studentApi.getCoachList()
        if (result) {
          this.coachList = result.map(item => ({
            id: item.id,
            name: item.nickName || item.userName
          }))
        }
      } catch (e) {
        console.error('加载教练列表失败', e)
      }
    },
    async loadDriverList() {
      try {
        const result = await studentApi.getDriverList()
        if (result) {
          this.driverList = result.map(item => ({
            id: item.id,
            name: item.nickName || item.userName
          }))
        }
      } catch (e) {
        console.error('加载司机列表失败', e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          keyword: this.searchForm.keyword,
          studentStatus: this.searchForm.studentStatus,
          coachUserId: this.searchForm.coachUserId,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        const result = await studentApi.getStudentList(params)
        if (result) {
          this.tableData = result.list || []
          this.total = result.total || 0
        }
      } catch (e) {
        console.error('加载数据失败', e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleAssign(row) {
      this.assignForm = {
        studentId: row.id,
        studentName: row.studentName,
        coachUserId: row.coachUserId,
        driverUserId: row.driverUserId
      }
      this.assignDialogVisible = true
    },
    async handleAssignSubmit() {
      try {
        await studentApi.assignCoachAndDriver({
          studentId: this.assignForm.studentId,
          coachUserId: this.assignForm.coachUserId,
          driverUserId: this.assignForm.driverUserId
        })
        this.$message.success('分配成功')
        this.assignDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '分配失败')
      }
    },
    getSubjectName(subject) {
      const map = {
        'K1': '科一(理论)',
        'K2': '科二(倒库)',
        'K3': '科三(路考)',
        'K4': '科四(安全)'
      }
      return map[subject] || subject || '-'
    },
    getStatusTagType(status) {
      const map = {
        'POTENTIAL': 'info',
        'ACTIVE': 'success',
        'COMPLETED': '',
        'DROPPED': 'danger',
        'REFUND_APPLY': 'warning',
        'ABANDON': 'danger'
      }
      return map[status] || ''
    },
    getStatusName(status) {
      const map = {
        'POTENTIAL': '潜在学员',
        'ACTIVE': '在学',
        'COMPLETED': '已毕业',
        'DROPPED': '已退学',
        'REFUND_APPLY': '申请退费',
        'ABANDON': '放弃学习'
      }
      return map[status] || status
    }
  }
}
</script>

<style scoped>
.coach-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.main-tabs {
  margin: 15px 20px;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.stats-cards {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #ebeef5;
}

.stat-card .stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 16px;
}

.stat-card .stat-icon.total { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.stat-card .stat-icon.hours { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.records { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.stat-card .stat-icon.pass { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }

.stat-card .stat-info .stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.stat-card .stat-info .stat-label {
  font-size: 14px;
  color: #909399;
}

.section-title {
  font-weight: bold;
  margin-bottom: 16px;
  color: #303133;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
}

.section-title i {
  margin-right: 8px;
  color: #409eff;
}

.el-table {
  background: #fff;
  border-radius: 4px;
}

.no-assign {
  color: #909399;
  font-style: italic;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 15px;
}

.total-text {
  font-size: 14px;
  color: #606266;
}
</style>
